import React from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import "./WebsiteDevelopment.css";

function WebsiteDevelopment() {
  const navigate = useNavigate();

  const siteUrl = "https://www.samsoftix.com";
  const pageUrl = `${siteUrl}/website_Service_Samsoftix`;

  const businessId = `${siteUrl}/#business`;

  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "@id": `${siteUrl}/#website`,
        "url": siteUrl,
        "name": "SamSoftix",
        "publisher": {
          "@id": businessId
        },
        "inLanguage": "en-PK"
      },

      {
        "@type": [
          "LocalBusiness",
          "ProfessionalService"
        ],
        "@id": businessId,
        "name": "SamSoftix",
        "url": siteUrl,
        "telephone": "+92-332-0472184",
        "email": "info@samsoftix.com",
        "description":
          "SamSoftix is a software house and training center providing website development, mobile app development, custom software, ecommerce, AI, SEO and IT solutions from Sambrial, Sialkot, Pakistan, with remote services for international clients.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Wan",
          "addressLocality": "Sambrial",
          "addressRegion": "Punjab",
          "postalCode": "51010",
          "addressCountry": "PK"
        },
        "areaServed": [
          {
            "@type": "City",
            "name": "Sambrial"
          },
          {
            "@type": "City",
            "name": "Sialkot"
          },
          {
            "@type": "Country",
            "name": "Pakistan"
          },
          {
            "@type": "Country",
            "name": "United Arab Emirates"
          },
          {
            "@type": "Country",
            "name": "Saudi Arabia"
          },
          {
            "@type": "Country",
            "name": "United States"
          },
          {
            "@type": "Country",
            "name": "United Kingdom"
          }
        ],
        "sameAs": [
          "https://www.facebook.com/samsoftix",
          "https://www.linkedin.com/company/samsoftix",
          "https://www.instagram.com/samsoftix"
        ]
      },

      {
        "@type": "WebPage",
        "@id": `${pageUrl}#webpage`,
        "url": pageUrl,
        "name":
          "International Website Development Company | USA, UAE & Saudi Arabia | SamSoftix",
        "description":
          "Website development services from SamSoftix for businesses in Pakistan and international markets including the USA, UAE and Saudi Arabia.",
        "isPartOf": {
          "@id": `${siteUrl}/#website`
        },
        "about": {
          "@id": `${pageUrl}#service`
        },
        "breadcrumb": {
          "@id": `${pageUrl}#breadcrumb`
        },
        "inLanguage": "en-PK"
      },

      {
        "@type": "BreadcrumbList",
        "@id": `${pageUrl}#breadcrumb`,
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": siteUrl
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Services",
            "item": `${siteUrl}/all_services`
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "Website Development",
            "item": pageUrl
          }
        ]
      },

      {
        "@type": "Service",
        "@id": `${pageUrl}#service`,
        "name": "Website Development Services",
        "serviceType": [
          "Website Development",
          "Business Website Development",
          "Web Application Development",
          "Responsive Website Development",
          "SEO-Friendly Website Development",
          "Ecommerce Website Development"
        ],
        "provider": {
          "@id": businessId
        },
        "areaServed": [
          {
            "@type": "Country",
            "name": "Pakistan"
          },
          {
            "@type": "Country",
            "name": "United States"
          },
          {
            "@type": "Country",
            "name": "United Arab Emirates"
          },
          {
            "@type": "Country",
            "name": "Saudi Arabia"
          },
          {
            "@type": "Country",
            "name": "United Kingdom"
          }
        ],
        "url": pageUrl,
        "description":
          "Professional website development for businesses, organizations and entrepreneurs, including responsive websites, web applications, ecommerce websites and SEO-friendly website architecture."
      },

      {
        "@type": "FAQPage",
        "@id": `${pageUrl}#faq`,
        "mainEntity": [
          {
            "@type": "Question",
            "name":
              "Does SamSoftix provide website development services in the USA, UAE and Saudi Arabia?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":
                "Yes. SamSoftix provides remote website development services for clients in the USA, United Arab Emirates including Dubai, Saudi Arabia and other international markets."
            }
          },
          {
            "@type": "Question",
            "name": "How much does a professional website cost?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":
                "Website development cost depends on the project scope, design requirements, functionality, integrations, content and technology stack. SamSoftix provides project-specific quotations after understanding the requirements."
            }
          },
          {
            "@type": "Question",
            "name": "Can you build an SEO-friendly website?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":
                "Yes. SamSoftix can structure websites with SEO-friendly page architecture, semantic content, responsive design, technical SEO considerations, metadata and performance-focused development."
            }
          },
          {
            "@type": "Question",
            "name": "Does SamSoftix develop ecommerce websites?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":
                "Yes. SamSoftix develops ecommerce websites using technologies and platforms such as Shopify, WooCommerce and custom web development depending on the project requirements."
            }
          },
          {
            "@type": "Question",
            "name": "Does SamSoftix provide website maintenance after launch?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text":
                "Yes. Website maintenance, updates, troubleshooting, hosting support and ongoing technical assistance can be provided according to the project requirements."
            }
          }
        ]
      }
    ]
  };

  return (
    <main className="webdev-page">
      <Helmet>
        <html lang="en-PK" />

        <title>
          Website Development Company | USA, UAE, Saudi Arabia & Pakistan |
          SamSoftix
        </title>

        <meta
          name="description"
          content="SamSoftix provides professional website development for businesses in Pakistan and international markets including the USA, UAE, Dubai and Saudi Arabia. Responsive, SEO-friendly business websites, ecommerce stores and web applications."
        />

        <meta
          name="keywords"
          content="website development company Pakistan, website development Sambrial, website development Sialkot, web development USA, web development Dubai, website development UAE, website development Saudi Arabia, international website development, business website development, ecommerce website development, React website development, Next.js development, SEO friendly websites"
        />

        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        />

        <meta
          name="googlebot"
          content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        />

        <meta name="author" content="SamSoftix" />

        <link rel="canonical" href={pageUrl} />

        {/* Geographic SEO */}
        <meta name="geo.region" content="PK-PB" />
        <meta
          name="geo.placename"
          content="Wan, Sambrial, Punjab, Pakistan"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Website Development Company | USA, UAE, Saudi Arabia & Pakistan | SamSoftix"
        />

        <meta
          property="og:description"
          content="Professional website development for businesses in Pakistan and international markets including the USA, UAE and Saudi Arabia."
        />

        <meta property="og:type" content="website" />

        <meta property="og:url" content={pageUrl} />

        <meta
          property="og:site_name"
          content="SamSoftix"
        />

        {/* Twitter */}
        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content="Website Development Services | SamSoftix"
        />

        <meta
          name="twitter:description"
          content="Responsive, SEO-friendly website development for businesses in Pakistan, USA, UAE, Saudi Arabia and other international markets."
        />

        <meta
          name="theme-color"
          content="#06111f"
        />

        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      {/* ================= HERO ================= */}
      <section className="webdev-hero">
        <div className="webdev-hero-content">
          <span className="webdev-kicker">
            WEBSITE DEVELOPMENT • SEO • WEB APPLICATIONS
          </span>

          <h1>
            Professional Website Development for
            <span> Local & International Businesses</span>
          </h1>

          <p>
            SamSoftix develops responsive, SEO-friendly and scalable websites
            for businesses in <strong>Pakistan</strong> and international
            markets including the <strong>USA</strong>,{" "}
            <strong>UAE</strong>, <strong>Dubai</strong> and{" "}
            <strong>Saudi Arabia</strong>.
          </p>

          <div className="webdev-location-tags">
            <span>🇵🇰 Pakistan</span>
            <span>🇺🇸 USA</span>
            <span>🇦🇪 UAE / Dubai</span>
            <span>🇸🇦 Saudi Arabia</span>
            <span>🌍 Remote Worldwide</span>
          </div>

          <div className="webdev-hero-actions">
            <button
              onClick={() => navigate("/serviceBooking")}
              className="webdev-btn"
            >
              Book a Website Consultation
            </button>
          </div>
        </div>
      </section>

      {/* ================= INTRO ================= */}
      <section className="webdev-section webdev-intro">
        <div className="webdev-section-inner">
          <span className="webdev-section-label">
            WEBSITE DEVELOPMENT SERVICES
          </span>

          <h2>
            Websites Built Around Your Business Goals
          </h2>

          <p>
            Your website is often the first point of contact between your
            business and potential customers. SamSoftix develops websites
            around your brand, target audience, content and business
            requirements rather than using a one-size-fits-all approach.
          </p>

          <p>
            From a professional business website to an ecommerce store or
            custom web application, we can help plan, design, develop,
            optimize and deploy your website.
          </p>
        </div>
      </section>

      {/* ================= WHY SAMSOFTIX ================= */}
      <section className="webdev-section">
        <div className="webdev-section-inner">
          <span className="webdev-section-label">
            WHY WORK WITH SAMSOFTIX
          </span>

          <h2>
            Website Development for Modern Businesses
          </h2>

          <div className="webdev-feature-grid">
            <article className="webdev-feature-card">
              <span>01</span>
              <h3>Responsive Development</h3>
              <p>
                Websites designed to provide a consistent experience across
                desktop, tablet and mobile devices.
              </p>
            </article>

            <article className="webdev-feature-card">
              <span>02</span>
              <h3>SEO-Friendly Architecture</h3>
              <p>
                Clean page structure, semantic content, metadata and
                performance considerations that support search engine
                discoverability.
              </p>
            </article>

            <article className="webdev-feature-card">
              <span>03</span>
              <h3>Modern UI & UX</h3>
              <p>
                Clear layouts, intuitive navigation and interfaces designed
                around your users and business objectives.
              </p>
            </article>

            <article className="webdev-feature-card">
              <span>04</span>
              <h3>Scalable Technology</h3>
              <p>
                Technology choices can be tailored to your project so the
                website can evolve as your business requirements change.
              </p>
            </article>

            <article className="webdev-feature-card">
              <span>05</span>
              <h3>Performance-Focused Development</h3>
              <p>
                We consider page structure, assets, code and hosting
                configuration to help create a fast and efficient website.
              </p>
            </article>

            <article className="webdev-feature-card">
              <span>06</span>
              <h3>Remote International Collaboration</h3>
              <p>
                We can work remotely with businesses in Pakistan and clients
                across international markets.
              </p>
            </article>
          </div>
        </div>
      </section>

      {/* ================= SERVICES ================= */}
      <section className="webdev-section webdev-services">
        <div className="webdev-section-inner">
          <span className="webdev-section-label">
            WHAT WE CAN BUILD
          </span>

          <h2>
            Website & Web Development Solutions
          </h2>

          <div className="webdev-services-grid">
            <article>
              <h3>Business Websites</h3>
              <p>
                Professional websites for companies, service providers,
                startups and local businesses.
              </p>
            </article>

            <article>
              <h3>Corporate Websites</h3>
              <p>
                Structured websites for organizations that need a clear
                presentation of their services, company information and
                contact channels.
              </p>
            </article>

            <article>
              <h3>Ecommerce Websites</h3>
              <p>
                Online stores using Shopify, WooCommerce or custom
                development depending on your requirements.
              </p>
            </article>

            <article>
              <h3>Custom Web Applications</h3>
              <p>
                Web-based systems designed for specific business workflows,
                dashboards, portals and internal operations.
              </p>
            </article>

            <article>
              <h3>Landing Pages</h3>
              <p>
                Focused landing pages for campaigns, services, products,
                lead generation and specific marketing objectives.
              </p>
            </article>

            <article>
              <h3>Website Redesign</h3>
              <p>
                Modernization of outdated websites with improved structure,
                responsive design and updated user experience.
              </p>
            </article>
          </div>
        </div>
      </section>

      {/* ================= INTERNATIONAL ================= */}
      <section className="webdev-section webdev-international">
        <div className="webdev-section-inner">
          <span className="webdev-section-label">
            INTERNATIONAL WEBSITE DEVELOPMENT
          </span>

          <h2>
            Supporting Businesses in the USA, UAE & Saudi Arabia
          </h2>

          <p>
            SamSoftix operates from Pakistan and provides remote development
            services for businesses outside Pakistan. Our website development
            workflow can be adapted to different markets, audiences and
            business requirements.
          </p>

          <div className="webdev-market-grid">
            <div>
              <strong>USA</strong>
              <p>
                Business websites, web applications, ecommerce and remote
                development services.
              </p>
            </div>

            <div>
              <strong>UAE / Dubai</strong>
              <p>
                Professional websites for companies, service businesses,
                startups and ecommerce brands.
              </p>
            </div>

            <div>
              <strong>Saudi Arabia</strong>
              <p>
                Responsive business websites and custom web solutions for
                organizations operating in the Saudi market.
              </p>
            </div>

            <div>
              <strong>Pakistan</strong>
              <p>
                Website development for businesses in Sambrial, Sialkot and
                other cities across Pakistan.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ================= TECHNOLOGIES ================= */}
      <section className="webdev-section">
        <div className="webdev-section-inner">
          <span className="webdev-section-label">
            TECHNOLOGY STACK
          </span>

          <h2>
            Technologies We Work With
          </h2>

          <p>
            Depending on the project requirements, SamSoftix can work with
            modern web technologies and platforms including:
          </p>

          <div className="webdev-tech-list">
            <span>React.js</span>
            <span>Next.js</span>
            <span>Node.js</span>
            <span>Firebase</span>
            <span>WordPress</span>
            <span>Shopify</span>
            <span>WooCommerce</span>
            <span>Cloud Hosting</span>
            <span>API Integration</span>
            <span>SEO Tools</span>
          </div>
        </div>
      </section>

      {/* ================= PROCESS ================= */}
      <section className="webdev-section webdev-process">
        <div className="webdev-section-inner">
          <span className="webdev-section-label">
            DEVELOPMENT PROCESS
          </span>

          <h2>
            Our Website Development Process
          </h2>

          <div className="webdev-process-grid">
            <article>
              <span>01</span>
              <h3>Requirements</h3>
              <p>
                We discuss your business, audience, website goals,
                functionality and technical requirements.
              </p>
            </article>

            <article>
              <span>02</span>
              <h3>Planning & UX</h3>
              <p>
                We organize the website structure, pages, navigation and
                user experience around the project requirements.
              </p>
            </article>

            <article>
              <span>03</span>
              <h3>Design & Development</h3>
              <p>
                The approved structure is converted into a responsive website
                using the selected technology or platform.
              </p>
            </article>

            <article>
              <span>04</span>
              <h3>SEO & Performance</h3>
              <p>
                We review page structure, metadata, responsiveness and
                performance-related implementation.
              </p>
            </article>

            <article>
              <span>05</span>
              <h3>Testing</h3>
              <p>
                Pages, forms, navigation, responsiveness and relevant
                functionality are checked before launch.
              </p>
            </article>

            <article>
              <span>06</span>
              <h3>Launch & Support</h3>
              <p>
                After deployment, ongoing maintenance and technical support
                can be arranged according to the project requirements.
              </p>
            </article>
          </div>
        </div>
      </section>

      {/* ================= FAQ ================= */}
      <section className="webdev-section webdev-faq">
        <div className="webdev-section-inner">
          <span className="webdev-section-label">
            FREQUENTLY ASKED QUESTIONS
          </span>

          <h2>
            Website Development FAQs
          </h2>

          <div className="webdev-faq-list">
            <article>
              <h3>
                Does SamSoftix work with clients in the USA and Middle East?
              </h3>
              <p>
                Yes. SamSoftix provides remote website development services
                for clients in Pakistan and international markets including
                the USA, UAE and Saudi Arabia.
              </p>
            </article>

            <article>
              <h3>
                How much does a professional website cost?
              </h3>
              <p>
                The cost depends on the number of pages, design requirements,
                functionality, integrations, content and technology used.
                We provide project-specific quotations based on requirements.
              </p>
            </article>

            <article>
              <h3>
                Can you build an SEO-friendly website?
              </h3>
              <p>
                Yes. Websites can be developed with SEO-friendly architecture,
                responsive design, metadata, semantic content and
                performance considerations.
              </p>
            </article>

            <article>
              <h3>
                Can you build Shopify or WooCommerce websites?
              </h3>
              <p>
                Yes. Ecommerce projects can be developed using Shopify,
                WooCommerce or custom solutions depending on the business
                requirements.
              </p>
            </article>

            <article>
              <h3>
                Do you provide website maintenance?
              </h3>
              <p>
                Yes. Maintenance, updates, troubleshooting, hosting support
                and other ongoing technical services can be arranged.
              </p>
            </article>
          </div>
        </div>
      </section>

      {/* ================= CTA ================= */}
      <section className="webdev-cta">
        <div className="webdev-cta-inner">
          <span className="webdev-section-label">
            START YOUR PROJECT
          </span>

          <h2>
            Need a Professional Website for Your Business?
          </h2>

          <p>
            Tell us about your business, target market and website
            requirements. SamSoftix can help you plan a suitable web
            development solution for your local or international audience.
          </p>

          <button
            onClick={() => navigate("/serviceBooking")}
            className="webdev-btn"
          >
            Request a Website Consultation
          </button>

          <div className="webdev-contact-line">
            <span>📧 info@samsoftix.com</span>
            <span>📱 +92 332 0472184</span>
            <span>🌍 Remote Worldwide</span>
          </div>
        </div>
      </section>
    </main>
  );
}

export default WebsiteDevelopment;